import HEAD from '@/components/Head.vue'
import NAVMENU from '@/components/Home.vue';
import TagsView from '@/components/TagsView';
import FButton from '@/components/FButton';
import SearchForm from '@/components/SearchForm';
import SearchFormWrap from '@/components/SearchFormWrap';
import ToolBar from "@/components/TableToolBar/index";
import TButton from "@/components/TableToolBar/TButton";
import FSingleImageUpload from "@/components/FSingleImageUpload";
import FPanel from '@/components/FPanel';

import PageWrapper from "@/components/PageWrapper/index";
import Operator from "@/components/operation/Operator";
import deviceType from "@/components/operation/deviceType";
import deviceModel from "@/components/operation/deviceModel";
import deviceModule from "@/components/operation/deviceModule";
import deviceTypeMultiple from "@/components/operation/deviceTypeMultiple";
import dishuOperator from "@/components/operation/dishuOperator";
import supplierSelect from "@/components/supplierSelect";
import batchSelect from "@/components/batchSelect";
import orderNumber from "@/components/operation/orderNumber";
import deviceModelMultipl from "@/components/operation/deviceModelMultipl";
import deviceHasMultipl from "@/components/operation/deviceHasMultipl";
import clineList from "@/components/operation/clineList";
import hardwar from "@/components/operation/hardwar";
import software from "@/components/operation/software";
import multipleClientName from "@/components/operation/MultipleClientName";
import operationLog from "@/components/operation/operationLog";
export default {
  install: function (Vue) {
    Vue.component('public-head', HEAD)
    Vue.component('public-nav', NAVMENU)
    Vue.component('tags-view', TagsView)
    Vue.component('f-button', FButton)
    Vue.component('search-from', SearchForm)
    Vue.component('search-from-wrap', SearchFormWrap)
    Vue.component('tool-bar', ToolBar)
    Vue.component('t-button', TButton)
    Vue.component('f-single-image-upload', FSingleImageUpload)
    Vue.component('page-wrapper',PageWrapper)
    Vue.component('f-panel',FPanel)
    Vue.component('operator',Operator)
    Vue.component('dishuOperator',dishuOperator)
    Vue.component('supplierSelect',supplierSelect)
    Vue.component('batchSelect',batchSelect)
    Vue.component('orderNumber',orderNumber)
    Vue.component('deviceType',deviceType)
    Vue.component('deviceModel',deviceModel)
    Vue.component('deviceModule',deviceModule)
    Vue.component('deviceTypeMultiple',deviceTypeMultiple)
    Vue.component('deviceModelMultipl',deviceModelMultipl)
    Vue.component('deviceHasMultipl',deviceHasMultipl)
    Vue.component('clineList',clineList)
    Vue.component('hardwarList',hardwar)
    Vue.component('softwareList',software)
    Vue.component('multipleClientName',multipleClientName)
    Vue.component('operationLog',operationLog)

  }
}



// WEBPACK FOOTER //
// ./src/components/index.js